export default __webpack_public_path__ + "static/transportation-573cca4487242c03421cac9937bba86c.png";